import "core-js/modules/es.array.map";
import React from 'react';
import { Grid } from "../../components/Layout";
import { useNotifications } from '../NotificationProvider';
import ItemWrapper from './ItemWrapper';

var NotificationList = function NotificationList() {
  var notifications = useNotifications();
  return /*#__PURE__*/React.createElement(Grid.Container, null, notifications.map(function (notification) {
    return /*#__PURE__*/React.createElement(ItemWrapper, {
      notification: notification,
      key: notification.id
    });
  }));
};

export default NotificationList;